/**
 * Belegprüfung – display helpers. The status is never computed here: every step only mirrors
 * a flag/timestamp delivered by the API (DocumentCheckResource).
 */

/**
 * @typedef {{ id: string, label: string, done: boolean, at?: string|null, hint?: string }} DocumentCheckStep
 */

/**
 * Stepper „Angelegt → Freigegeben → Bestätigt/bereit → Eigentümer informiert → Abgeschlossen“.
 * @param {{ released_to_auditors?: boolean, is_ready?: boolean, ready_at?: string|null, owner_info_sent_at?: string|null, documents_sent_at?: string|null, is_completed?: boolean } | null | undefined} check
 * @returns {{ steps: DocumentCheckStep[], current: string|null }}  current = first step that is not done (null = all done)
 */
export function documentCheckSteps(check) {
  const c = check ?? {};
  const informedAt = c.owner_info_sent_at ?? c.documents_sent_at ?? null;
  /** @type {DocumentCheckStep[]} */
  const steps = [
    { id: 'created', label: 'Angelegt', done: true },
    { id: 'released', label: 'Freigegeben', done: Boolean(c.released_to_auditors), hint: 'für Kassenprüfer' },
    { id: 'ready', label: 'Bestätigt/bereit', done: Boolean(c.is_ready), at: c.ready_at ?? null },
    { id: 'owners_informed', label: 'Eigentümer informiert', done: Boolean(informedAt), at: informedAt },
    { id: 'completed', label: 'Abgeschlossen', done: Boolean(c.is_completed) },
  ];
  return { steps, current: steps.find((s) => !s.done)?.id ?? null };
}

/** Folder keys of a Belegprüfung (DocumentCheck::FOLDERS) plus the internal receipt folder of the booking list import. */
export const DOCUMENT_CHECK_RECEIPT_FOLDER = '_wincasa_belege';
